const birdprotection_confirmsend_reducer = (state = false, action) => {
	switch(action.type) {

		case 'UPDATEBPCONFIRMSEND':
			return typeof action.payload !== "undefined" ? action.payload : false;

		default:
			return state;
	}
}

export default birdprotection_confirmsend_reducer;